import { UnitType } from '@exodus/currency'

const name = 'dash'
const displayName = 'Dash'
const ticker = 'DASH'
const displayTicker = 'DASH'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#12CEF7'
const gradientColors = ['#12CEF7', '#5766F2']
const gradientCoords = { x1: '0%', y1: '0%', x2: '102%', y2: '101%' }
const chainBadgeColors = gradientColors

const units = {
  duffs: 0,
  DASH: 8,
}
const currency = UnitType.create(units)

const assetType = 'BITCOIN_LIKE'
const blockExplorer = {
  addressUrl: (address) => `https://blockchair.com/dash/address/${address}`,
  txUrl: (txId) => `https://blockchair.com/dash/transaction/${txId}`,
}
const info = {
  description:
    'Dash is a cryptocurrency that aims to improve on the Bitcoin protocol. Instead of being reliant on donations and investment for development, Dash is self-funded, eliminating conflicts of interest. It is also democratic, as anyone can submit treasury proposals to improve the protocol.',
  reddit: 'https://www.reddit.com/r/dashpay/',
  twitter: 'https://twitter.com/dashpay',
  website: 'https://www.dash.org/',
}

export const tokens = undefined
export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated,
  properTicker: displayTicker, // deprecated,
  ticker,
  toString: () => name,
  units,
}

export default [asset]
